import React from "react";
import type { PropsWithChildren } from "react";

import { verticalProductCardFooter } from "./VerticalProductCard.css";

export const VerticalProductCardFooter: React.FC<PropsWithChildren> = ({
  children
}) => {
  return <div className={verticalProductCardFooter}>{children}</div>;
};
